import { EventsScreen } from '@/components/domain/events/EventsScreen';

export default function EventsPast() {
  return <EventsScreen initialListType="past" />;
}
